import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import React, { useEffect, useState } from "react";

import { ContainerContent } from "@/components/Common/Dashboard/ContainerContent";
import { ContainerTitle } from "@/components/Common/Dashboard/ContainerTitle";

import { addToast, toastMessageTypes } from "../../../../redux/actions/toaster";
import Captcha from "../../../../components/Common/Captcha/Captcha";
import { displayElavonCreditCardModal } from "../../../../utils/PaymentProvider/elavon";
import {
  fetchPatientCardInfo,
  putPatientCardInfo,
} from "../../../../redux/actions/patientCardInfo";
import { fetchPaymentProcessorSessionToken } from "../../../../redux/actions/paymentProcessor";
import { shouldShowVulnerablePages } from "../../../../utils/authUtils";

import CardSection from "./CardSection";
import PayBillSection from "./PayBillSection";

import "./styles.scss";

const PAYMENT_EXPIRED_MESSAGE = "Your card has expired. Please update it.";

const PaymentsPage = ({
  cardInfo,
  dispatch,

  fetchPatientCardInfo,

  history,
  profile,
}) => {
  const [errorMessage, setErrorMessage] = useState();
  const [captchaVerificationToken, setCaptchaVerificationToken] = useState(false);

  const {
    expirationDate, //MMYY
    lastFourDigits, //XXXX
  } = cardInfo;

  const expirationDateMoment = expirationDate ? moment(expirationDate) : undefined;
  const isExpired = expirationDateMoment ? moment().diff(expirationDateMoment) > 0 : false;

  useEffect(() => {
    if (!shouldShowVulnerablePages(profile.status)) {
      history.push("/app/home");
    }

    if ((profile && !cardInfo.username) || (profile && cardInfo.username !== profile.username)) {
      fetchPatientCardInfo();
    }
  }, [cardInfo.username, profile?.username]);

  const handleElavonCreditCardModalException = (e) => {
    if (!e?.code || e?.code >= 500) {
      dispatch(
        addToast({
          message: "Unexpected error adding card on file. Please try again later.",
          messageType: toastMessageTypes.error_v2,
        }),
      );
    }
    throw e;
  };

  const onAddCardButtonClick = async () => {
    try {
      await displayElavonCreditCardModal(
        dispatch,
        profile.username,
        profile.first_name,
        profile.last_name,
        setErrorMessage,
        "MEMBER_PROFILE",
        null,
        null,
        null,
        null,
        true,
        captchaVerificationToken,
        history,
      );
    } catch (e) {
      handleElavonCreditCardModalException(e);
    }
    setCaptchaVerificationToken(null);
  };

  const captchaComponent = <Captcha setCaptchaVerificationToken={setCaptchaVerificationToken} />;

  return (
    <ContainerContent>
      <ContainerTitle title="Payment" />

      <CardSection
        captchaCompleted={captchaVerificationToken}
        captchaComponent={captchaComponent}
        errorMessage={errorMessage ? errorMessage : isExpired ? PAYMENT_EXPIRED_MESSAGE : undefined}
        expirationDate={expirationDateMoment}
        isExpired={isExpired}
        lastFourDigits={lastFourDigits}
        onAddCardButtonClick={onAddCardButtonClick}
        onReplaceCardButtonClick={onAddCardButtonClick}
        profile={profile}
        resetCaptcha={() => setCaptchaVerificationToken(null)}
      />
      <PayBillSection />
    </ContainerContent>
  );
};

const mapStateToProps = (state) => ({
  cardInfo: state.patientCardInfo,
  profile: state.auth.profile,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(
    {
      addToast,
      fetchPatientCardInfo,
      fetchPaymentProcessorSessionToken,
      putPatientCardInfo,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentsPage);
